module.exports = __webpack_public_path__ + "img/hands-up.affb8ba4.png";